import { put } from "redux-saga/effects";

import makeRequest from "rdx/utils/makeRequest";
// import getErrorActions from "rdx/utils/getErrorActions";
import actions from "rdx/actions";
// import messages from "../messages";

function* getZipAddress(action) {
  const { zip } = action.payload;

  const { success, data, error } = yield* makeRequest.get(`/zips/${zip}`, {});

  if (success && data) {
    yield put(actions.setZipLookupAddress({ ...data.body, zip }));
  } else if (error) {
    if (error.message === "Invalid zipcode" || error.message === "not found") {
      yield put(actions.setZipLookupAddress({ zip, invalid: true }));
    }
  }

  return null;
}

export default getZipAddress;
